module.exports = __webpack_public_path__ + "img/search1.e68981ba.png";